import React, { useState } from "react";
import { RiSendPlaneFill } from "react-icons/ri";
import { HiOutlineMail } from "react-icons/hi";
import { BiLogoFacebook, BiLogoInstagram } from "react-icons/bi";
import {
  FaPhone,
  FaMapMarkerAlt,
  FaChevronDown,
  FaChevronUp,
} from "react-icons/fa";
import { RxTwitterLogo } from "react-icons/rx";
import { AiOutlineLinkedin } from "react-icons/ai";
import logo from "../../assets/logo.png";
import { Link } from "react-router-dom";
import toast from "react-hot-toast";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import AppService from "../../service/AppService";

const Footer = () => {
  const [email, setEmail] = useState("");
  const [expandedSection, setExpandedSection] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [currentPdfUrl, setCurrentPdfUrl] = useState("");
  const [currentPdfTitle, setCurrentPdfTitle] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleSubscribe = (e) => {
    e.preventDefault();
    if (email) {
      toast.success("Thank you for subscribing!");
      setEmail("");
    } else {
      toast.error("Please enter a valid email");
    }
  };

  const toggleSection = (section) => {
    if (expandedSection === section) {
      setExpandedSection(null);
    } else {
      setExpandedSection(section);
    }
  };

  const isExpanded = (section) => expandedSection === section;

  const toggleModal = () => setModalOpen(!modalOpen);

  const openDocument = async (e, type) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      let title = "Document";
      if (type === "TERMS_AND_CONDITIONS") title = "Terms & Conditions";
      else if (type === "PRIVACY_POLICY") title = "Privacy Policy";
      else if (type === "REFUND_POLICY") title = "Refund Policy";
      
      const response = await AppService.getDocumentByType(type, { responseType: 'blob' });
      const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
      
      setCurrentPdfUrl(url);
      setCurrentPdfTitle(title);
      setModalOpen(true);
    } catch (err) {
      toast.error(err.response?.data?.failedReason || "Failed to load document");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <footer className="bg-gradient-to-br from-[#2a133c] to-[#662d91] text-white py-4">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {/* Company Info Section */}
          <div className="md:pr-4">
            <div className="flex items-center justify-between mb-2">
              <div className="flex items-center">
                <img
                  src={logo}
                  alt="Nine and Fine"
                  className="h-8 brightness-0 invert"
                />
              </div>
              <button
                className="md:hidden"
                onClick={() => toggleSection("contact")}
              >
                {isExpanded("contact") ? <FaChevronUp /> : <FaChevronDown />}
              </button>
            </div>
            <div
              className={`space-y-2 ${isExpanded("contact") ? "block" : "hidden md:block"}`}
            >
              {/*<div className="flex items-center space-x-2">
                <FaPhone className="text-[#a247e6]" />
                <a
                  href="tel:18002665533"
                  className="text-sm hover:text-[#a247e6] transition-colors"
                >
                  1800 266 5533
                </a>
              </div>*/}
              <div className="flex items-center space-x-2">
                <HiOutlineMail className="text-[#a247e6]" />
                <a
                  href="mailto:support@nineandfine.com"
                  className="text-sm hover:text-[#a247e6] transition-colors"
                >
                  support@nineandfine.com
                </a>
              </div>
              {/*<div className="flex items-center space-x-2">
                <FaMapMarkerAlt className="text-[#a247e6]" />
                <span className="text-sm">T Nagar, Chennai - 600017</span>
              </div>*/}
            </div>
          </div>

          {/* Quick Links Section */}
          <div className="md:border-l md:border-r border-gray-600 md:px-4">
            <div className="flex items-center justify-between mb-2">
              <h3 className="text-base font-semibold">Quick Links</h3>
              <button
                className="md:hidden"
                onClick={() => toggleSection("links")}
              >
                {isExpanded("links") ? <FaChevronUp /> : <FaChevronDown />}
              </button>
            </div>
            <div
              className={`${isExpanded("links") ? "block" : "hidden md:block"}`}
            >
              <div className="grid grid-cols-1 gap-2">
                <Link
                  to="/contact"
                  className="text-sm text-gray-300 hover:text-[#a247e6] transition-colors"
                >
                  Contact Us
                </Link>
                <a
                  href="#"
                  onClick={(e) => openDocument(e, "TERMS_AND_CONDITIONS")}
                  className="text-sm text-gray-300 hover:text-[#a247e6] transition-colors"
                >
                  Terms & Conditions
                </a>
                <a
                  href="#"
                  onClick={(e) => openDocument(e, "PRIVACY_POLICY")}
                  className="text-sm text-gray-300 hover:text-[#a247e6] transition-colors"
                >
                  Privacy Policy
                </a>
                {/* <a
                  href="#"
                  onClick={(e) => openDocument(e, "REFUND_POLICY")}
                  className="text-sm text-gray-300 hover:text-[#a247e6] transition-colors"
                >
                  Refund Policy
                </a> */}
              </div>
            </div>
          </div>

          {/* Newsletter Section */}
          {/* <div className="md:pl-4">
            <div className="flex items-center justify-between mb-2">
              <h3 className="text-base font-semibold">Stay Connected</h3>
              <button
                className="md:hidden"
                onClick={() => toggleSection("newsletter")}
              >
                {isExpanded("newsletter") ? <FaChevronUp /> : <FaChevronDown />}
              </button>
            </div>
            <div
              className={`${isExpanded("newsletter") ? "block" : "hidden md:block"}`}
            >
              <form onSubmit={handleSubscribe} className="flex mb-2 w-full">
                {" "}
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Enter your email"
                  className="flex-1 min-w-0 px-3 py-1 text-sm rounded-l-md focus:outline-none focus:ring-1 focus:ring-[#a247e6] text-gray-800"
                />
                <button
                  type="submit"
                  className="shrink-0 bg-[#662d91] hover:bg-[#a247e6] px-3 py-1 rounded-r-md transition-colors duration-200 flex items-center"
                >
                  <RiSendPlaneFill className="text-sm" />
                </button>
              </form>
              <div className="flex space-x-3">
                <a
                  href="#"
                  className="text-gray-400 hover:text-[#a247e6] transition-colors"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <BiLogoFacebook size={20} />
                </a>
                <a
                  href="#"
                  className="text-gray-400 hover:text-[#a247e6] transition-colors"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <BiLogoInstagram size={20} />
                </a>
                <a
                  href="#"
                  className="text-gray-400 hover:text-[#a247e6] transition-colors"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <RxTwitterLogo size={20} />
                </a>
                <a
                  href="#"
                  className="text-gray-400 hover:text-[#a247e6] transition-colors"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <AiOutlineLinkedin size={20} />
                </a>
              </div>
            </div>
          </div> */}
        </div>

        {/* Copyright */}
        <div className="text-center pt-3 mt-3 border-t border-gray-600">
          <p className="text-xs text-gray-400">
            © {new Date().getFullYear()} All rights reserved. Finenine Wellness Pvt Ltd
          </p>
        </div>
      </div>

      {isLoading && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-white"></div>
        </div>
      )}

      <Modal isOpen={modalOpen} toggle={toggleModal} size="xl" className="modal-dialog-centered text-black" style={{ maxWidth: '1000px' }}>
        <ModalHeader toggle={toggleModal} className="w-full flex justify-between items-center text-[#2a133c] text-xl font-bold border-b border-gray-200" close={<button className="close text-[#662d91] hover:text-[#a247e6] font-bold text-4xl ml-auto bg-transparent border-0" onClick={toggleModal}>&times;</button>}>
          {currentPdfTitle}
        </ModalHeader>
        <ModalBody style={{ height: '85vh', padding: 0 }}>
          {currentPdfUrl ? (
            <iframe
              src={currentPdfUrl}
              width="100%"
              height="100%"
              title={currentPdfTitle}
              style={{ border: 'none' }}
            />
          ) : (
            <div className="p-4 text-center">Document not available.</div>
          )}
        </ModalBody>
      </Modal>
    </footer>
  );
};

export default Footer;
